/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import { Dropdown, Tooltip, Modal } from 'antd'
import styled from 'styled-components'
import useAuth from 'hooks/useAuth'
import { deleteAuthToken } from 'library/FetchHelper'
import useToast from 'hooks/useToast'
import { compactAddress } from 'helpers'
import LogOut from 'widgets/Svg/Icons/LogOut'
import { loadBlockchainData } from 'hooks/setGetBalance'
import { useCreateTokenContract } from 'hooks/useContract'
import { CONTRACT_TOKEN_ASDIT, TOKEN_BUSD } from 'config/constants'
import { formatNumber } from 'utils/formatBalance'
import { useFormatCurrency } from 'hooks/useFormatCurrency'
import { useSelector } from 'react-redux'
import { copyText } from 'utils/copyText'
import { useCalculateSwapOutput } from 'hooks/useCalculateSwapOutput'

const CustomeMenuWallet = styled.div`
  min-width: 333px;
  max-width: 100%;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  /* overflow: hidden; */

  ${({ theme }) => theme.mediaQueries.lg} {
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(5px);
  }

  .ant-dropdown-menu {
    background: #ffffff;
    box-shadow: none;
  }

  .header-wallet {
    padding: 0 8px 0px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 36px;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.5);

    p {
      &:first-child {
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 18px;
        color: #000000;
      }

      img {
        &:not(:last-child) {
          margin-right: 7px;
        }
      }

      span {
        &:not(:last-child) {
          margin-right: 7px;
        }
      }

      svg {
        path {
          transition: 0.2s;
        }

        &:hover {
          path {
            transition: 0.2s;
            fill: #006dfe;
          }
        }
      }
    }
  }

  .body-wallet {
    padding-top: 16px;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.5);

    .item-body {
      display: flex;
      justify-content: space-between;
      padding: 0 8px 16px 8px;

      p {
        &:first-child {
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
          color: #000000;
        }

        &.chain {
          font-family: 'Inter';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 15px;
          color: #000000;
        }

        &.crypto {
          font-style: normal;
          font-weight: 700;
          font-size: 16px;
          line-height: 20px;
          text-align: right;
          color: #000000;

          span {
            display: block;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 15px;
            text-align: right;
            color: #aaaaaa;
          }

          img {
            width: 16px;
          }
        }

        &.flex {
          display: flex;
          align-items: center;
        }
      }

      .btn-reload {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        min-height: 16px;
        padding: 3px;
        margin-left: 5px;
        margin-top: 3px;

        &:hover {
          background: linear-gradient(143.11deg, #006dfe 21.44%, #43e8e1 126.28%);
        }

        img {
          width: 100%;
          margin-left: 1px;
        }

        &.loading {
          img {
            animation: rotateAround 1s infinite;
          }
        }
      }
    }
  }

  button {
    background: #006dfe;
    width: 100%;
    min-height: 41px;
    border: none;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: #ffffff;
    cursor: pointer;

    &:hover {
      background: linear-gradient(143.11deg, #006dfe 21.44%, #43e8e1 126.28%);
    }
  }

  .ml-1 {
    margin-left: 7px;
  }

  .hidden {
    opacity: 0;
  }
`

const ContentModal = styled.div`
  background-color: #fff;
  margin: -24px;
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  overflow: hidden;

  .title-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    min-height: 48px;
    border-bottom: 1px solid #6d6d6d;

    p {
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 30px;
      text-align: center;
      color: #006dfe;
    }
  }

  .body-modal {
    .control-body-modal {
      display: flex;
      align-items: center;

      button {
        position: relative;
        background: transparent;
        width: 50%;
        height: 60px;
        border: none;
        border-bottom: 2px solid #d9d9d9;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 18px;
        text-align: center;
        color: #6d6d6d;
        cursor: pointer;

        span {
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translate(-50%, -3px);
          display: block;
          max-width: 92px;
          margin: auto;
          font-family: 'Inter';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 15px;
          text-align: center;
          color: #ffffff;
          background: #006dfe;
          border-radius: 5px;
          padding: 1px 3px;
        }

        &.active {
          color: #000000;
          border-bottom: 2px solid #006dfe;
        }
      }
    }

    .content-body-modal {
      padding: 30px 15px;
      max-width: 404px;
      margin: 0 auto;
      text-align: center;

      img {
        margin-bottom: 16px;
      }

      > p {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        color: #000000;
        margin-bottom: 19px;
      }

      .copy-address {
        display: flex;
        align-items: center;
        width: 100%;
        flex: 1;

        p {
          font-family: 'Inter';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 19px;
          color: #a7a7a7;
          width: 100%;
          height: 36px;
          overflow: hidden;
          padding: 8px 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
          border: 1px solid #c7c7c7;
          border-radius: 5px;
          margin-right: 5px;
        }

        button {
          height: 36px;
          width: 74px;
          background: #006dfe;
          border-radius: 5px;
          border: none;
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
          text-align: center;
          color: #ffffff;
          cursor: pointer;

          &:hover,
          &:active {
            background: linear-gradient(143.11deg, #006dfe 21.44%, #43e8e1 126.28%);
            border-radius: 5px;
          }
        }
      }
    }
  }

  .mr-1 {
    margin-right: 7px;
  }
`

const BoxWallet = styled.div`
  position: relative;

  img {
    &:nth-child(2) {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;
      transition: 0.2s;
      z-index: 1;
    }
  }

  &:not(.is-scroll) {
    img {
      &:nth-child(2) {
        filter: blur(5px);
        z-index: -1;
      }
    }
  }

  &:hover {
    img {
      &:nth-child(2) {
        opacity: 1;
        transition: 0.2s;
      }
    }
  }

  &.hover {
    img {
      &:nth-child(2) {
        opacity: 1;
        transition: 0.2s;
      }
    }
  }
`

const MenuWallet = ({ isScroll, refContainerDropdown }) => {
  const { logout } = useAuth()
  const { toastSuccess }: any = useToast()
  const { currencyRate } = useSelector((state: any) => state.balances)
  const { account } = useWeb3React()
  const accountEllipsis = account ? compactAddress(account) : undefined
  const tokenContract = useCreateTokenContract(TOKEN_BUSD)
  const tokenContractSoei = useCreateTokenContract(CONTRACT_TOKEN_ASDIT)
  const [getFormatCurrency] = useFormatCurrency()
  const convertOutput = useCalculateSwapOutput()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isCopyText, setIsCopyText] = useState(false)
  const [balance, setBalance] = useState<any>('')
  const [loading, setLoading] = useState(false)
  const [visibleDropdown, setVisibleDropdown] = useState(false)
  const [balanceSoeiUSDT, setBalanceSoeiUSDT] = useState<any>('')

  const getBalance = useCallback(async () => {
    const balanceBUSD = await tokenContract.balanceOf(account)
    const balanceSOEI = await tokenContractSoei.balanceOf(account)

    setBalance({
      BNB: await loadBlockchainData(account),
      BUSD: parseInt(balanceBUSD?.toString(), 10) / 10 ** 9,
      SOEI: parseInt(balanceSOEI?.toString(), 10) / 10 ** 18,
    })

    const result = await convertOutput('SOI', balanceSOEI?.toString())
    setBalanceSoeiUSDT(parseInt(result?.toString(), 10) / 10 ** 18)
  }, [account, convertOutput, tokenContract, tokenContractSoei])

  const reloadBalance = () => {
    setLoading(true)
    setTimeout(() => setLoading(false), 1000)
    getBalance()
  }

  useEffect(() => {
    getBalance()
  }, [getBalance])

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleOk = () => {
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const menuWallet = (
    <CustomeMenuWallet>
      <div className="header-wallet">
        <p>
          <img src="/images/icons/wallet-light.svg" alt="" />
          <span>My wallet</span>
        </p>
        <p style={{ display: 'flex', alignItems: 'center' }}>
          <img src="/images/icons/metamask.png" alt="" />
          <span>{accountEllipsis}</span>
          <Tooltip
            placement="bottom"
            title={<p style={{ color: '#6D6D6D', fontWeight: '700' }}>Logout</p>}
            color="#ffffff"
          >
            <LogOut
              style={{ cursor: 'pointer' }}
              onClick={() => {
                logout()
                deleteAuthToken()
                toastSuccess('Logout successful')
              }}
            />
          </Tooltip>
        </p>
      </div>

      <div className="body-wallet">
        <div className="item-body">
          <p>Chain</p>
          <p className="chain">
            Binance Smart Chain <img className="ml-1" src="/images/icons/bsc-chain.png" alt="" />
          </p>
        </div>

        <div className="item-body">
          <p className="flex">
            Crypto{' '}
            <button
              type="button"
              disabled={loading}
              className={`btn-reload ${loading ? 'loading' : ''}`}
              onClick={() => reloadBalance()}
            >
              <img src="/images/icons/reload.svg" alt="reload" />
            </button>
          </p>
          <p className="crypto">
            {balance?.BNB?.balance && formatNumber(balance?.BNB?.balance, 0)} BNB{' '}
            <img className="ml-1" src="/images/icons/bnb.svg" alt="" />
            <span>
              ~{getFormatCurrency(+balance?.BNB?.balance * +currencyRate?.binancecoin?.usd)}{' '}
              <img className="ml-1 hidden" src="/images/icons/bnb.svg" alt="" />
            </span>
          </p>
        </div>

        <div className="item-body">
          <p style={{ opacity: 0 }}>Crypto</p>
          <p className="crypto">
            {balance?.BUSD && formatNumber(balance?.BUSD, 0)} USDT{' '}
            <img className="ml-1" src="/images/coins/usdt.svg" alt="" />
            <span>
              ~{getFormatCurrency(+balance?.BUSD * +currencyRate?.['binance-usd']?.usd)}{' '}
              <img className="ml-1 hidden" src="/images/coins/usdt.svg" alt="" />
            </span>
          </p>
        </div>

        <div className="item-body">
          <p style={{ opacity: 0 }}>Crypto</p>
          <p className="crypto">
            {balance?.SOEI && formatNumber(balance?.SOEI, 0)} SOI{' '}
            <img className="ml-1" src="https://socoin.io/images/tokens/SOI.svg" alt="" />
            <span>
              ~{getFormatCurrency(+balanceSoeiUSDT)}{' '}
              <img className="ml-1 hidden" src="https://socoin.io/images/tokens/SOI.svg" alt="" />
            </span>
          </p>
        </div>
      </div>

      <div className="body-wallet" style={{ border: 'none' }}>
        <div className="item-body">
          <p>Total Balance</p>
          <p className="crypto">
            ~
            {getFormatCurrency(
              +balance?.BNB?.balance * +currencyRate?.binancecoin?.usd +
                +balance?.BUSD * +currencyRate?.['binance-usd']?.usd,
            )}
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={() => {
          showModal()
          setVisibleDropdown((prev) => !prev)
        }}
      >
        Add Funds
      </button>
    </CustomeMenuWallet>
  )

  const handleVisibleChange = (flag: boolean) => {
    setVisibleDropdown(flag)
  }

  const handleCopy = () => {
    setIsCopyText(true)
    setTimeout(() => {
      setIsCopyText(false)
    }, 3000)
  }

  return (
    <>
      <div style={{ margin: '0 0 0 24px', cursor: 'pointer' }}>
        <Dropdown
          overlay={menuWallet}
          placement="bottom"
          trigger={['click']}
          open={visibleDropdown}
          onOpenChange={handleVisibleChange}
          getPopupContainer={() => refContainerDropdown.current}
        >
          {isScroll ? (
            <BoxWallet className={`is-scroll ${visibleDropdown ? 'hover' : ''}`}>
              <img src="/images/icons/wallet.svg" alt="" />
              <img src="/images/icons/wallet-blue.svg" alt="" />
            </BoxWallet>
          ) : (
            <BoxWallet className={visibleDropdown ? 'hover' : ''}>
              <img src="/images/icons/wallet-white.svg" alt="" />
              <img src="/images/icons/wallet-white.svg" alt="" />
            </BoxWallet>
          )}
        </Dropdown>
      </div>

      <Modal
        width="483px"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
        closeIcon={<img style={{ marginTop: '-17px' }} src="/images/header/close.svg" alt="" />}
      >
        <ContentModal>
          <div className="title-modal">
            <p>Add Funds</p>
          </div>

          <div className="body-modal">
            <div className="control-body-modal">
              <button className="active" type="button">
                <img className="mr-1" src="/images/header/arrow-down.svg" alt="" />
                Deposit Crypto
              </button>
              <button type="button">
                Buy with card <span>Comming soon</span>
              </button>
            </div>

            <div className="content-body-modal">
              <img src="/images/header/wallet.png" alt="" />

              <p>Transfer funds from an exchange or another wallet to your wallet address below:</p>

              <div className="copy-address">
                <p>{account}</p>
                <button type="button" onClick={() => copyText(account, handleCopy)} disabled={isCopyText}>
                  {isCopyText ? 'Copied' : 'Copy'}
                </button>
              </div>
            </div>
          </div>
        </ContentModal>
      </Modal>
    </>
  )
}

export default MenuWallet
